import styled from 'styled-components';

export const GalleryContainer = styled.div`
background: #F0FFE6;
width: 100%;
height: 100%;
position: relative;
`;

export const GalleryWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 50px 25px;
`;

export const GalleryWhiteWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
padding: 50px 25px;
background: #fff;
border-radius: 25px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
`;

export const GalleryGridWrapper = styled.div`
display: grid;
grid-template-columns: repeat(4, 1fr);
gap: 25px;
width: 100%;
height: 100%;
padding: 25px;

@media screen and (max-width: 1200px){
    grid-template-columns: repeat(3, 1fr);
}

@media screen and (max-width: 768px){
    grid-template-columns: repeat(2, 1fr);
}

@media screen and (max-width: 480px){
    grid-template-columns: repeat(1, 1fr);
}
`;

export const IconDetailsHeader = styled.h3`
font-size: 36px;
color: #000;
text-align: center;
font-weight: bold;

@media screen and (max-width: 768px){
    font-size: 28px;
}

@media screen and (max-width: 480px){
    font-size: 24px;
}
`;

export const IconDetailWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
gap: 10px;
background: #F8F8F8;
border-radius: 25px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
padding: 10px;
`;

export const IconImage = styled.img`
width: 100%;
height: auto;
max-width: 200px;
`;

export const IconHeader = styled.h4`
font-size: 24px;
font-weight: bold;
color: #33682c;

@media screen and (max-width: 768px){
    font-size: 18px;
}

@media screen and (max-width: 480px){
    font-size: 16px;
}
`;

export const IconText = styled.p`
font-size: 16px;
color: #000;

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 12px;
}
`;
